import React, { useCallback, useEffect, useState } from "react";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import useThreadsStore from "shared/store/threadsStore";
type SectionChildrenProps = {
  threadId: any;
  portfolioId: any;
  keepLoading?: boolean;
};

const CommentoContainer: React.FC<SectionChildrenProps> = ({
  threadId,
  portfolioId,
  keepLoading = false,
}) => {
  const [story, setStory] = useState<string>("Generazione in corso...");

  const fetchStoryLocal = useThreadsStore((state) => state.fetchStory);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [story]);

  // Helper to extract current story from the global store
  const getStory = () => {
    const stories = useThreadsStore.getState().stories;
    return stories?.[threadId]?.[portfolioId] ?? null;
  };

  useEffect(() => {
    fetchAllData(12);
  }, []);

  const fetchAllData = useCallback(
    async (iterations) => {
      if (iterations > 0) {
      } else return;
      const result = getStory();
      if (result === null) {
        fetchStoryLocal(threadId, portfolioId);

        setTimeout(() => fetchAllData(iterations - 1), 5000);
        return false;
      }

      if (result !== null && result !== "") {
        setTimeout(() => setStory(result), 40);
        return true;
      }

      // proceed with your data fetching logic...
    },
    [threadId, portfolioId],
  );

  return (
    <div
      style={{ marginBottom: 10, marginLeft: 5, marginRight: 5, marginTop: 16 }}
    >
      <div className={styles.tableBackground}>
        <div style={{ padding: 16 }}>{story}</div>
      </div>
    </div>
  );
};

export default React.memo(CommentoContainer);
